export default "__VITE_ASSET__DLW7f2Hb__"